import { LineItemQuantity } from 'theme';

let cartDataCache = null;
let lastCacheTime = 0;
let cacheExpiry = 500;

const CART_ATTRIBUTE_KEY = 'email_campaign';

const campaignFreeGift = async () => {
    init({ firstInit: true, event: null });
    addEventListeners();
};

const init = async ({ firstInit = false, event = null }) => {

    if (firstInit == true) {
        if (gtc.freeGiftCampaigns.length > 0) {
            for (const campaign of gtc.freeGiftCampaigns) {
                if ((campaign.item_added == true && campaign.progress < 100) || (campaign.item_added == true && !gtc.activeCampaigns.includes(campaign.handle))) {
                    removeProduct({ variantId: campaign.item_id });
                    return;
                }
            }
        }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const emailCampaignHandle = urlParams.get('campaign');
    let campaignHandles = window.gtc.activeCampaigns;
    let triggerCampaignFirstLoadRefresh = false;


    if (emailCampaignHandle && !campaignHandles.includes(emailCampaignHandle)) {
        triggerCampaignFirstLoadRefresh = true;
    }

    if (emailCampaignHandle) {

        campaignHandles.push(emailCampaignHandle);
        campaignHandles = [...new Set(campaignHandles)];
        updateCartProperty(CART_ATTRIBUTE_KEY, emailCampaignHandle, () => {
            if (triggerCampaignFirstLoadRefresh) {
                window.location.reload();
            }
        });
    }

    if (!campaignHandles || campaignHandles.length == 0) {
        return;
    }

    const dataArray = await fetchCartData();


    for (const campaignHandle of campaignHandles) {
        const dataMatch = dataArray.find(data => data.handle === campaignHandle);

        if (dataMatch == null) {
            return;
        }

        const { handle, item_id, item_manually_removed, item_status } = dataMatch;

        if (item_manually_removed == true) {
            return;
        }


        switch (item_status) {
            case 'add':
                addProduct({ variantId: item_id, event: event, properties: { "_gift_item": handle } });
                return;
            case 'reduce':
                changeProduct({ variantId: item_id, quantity: 1 });
                return;
            case 'remove':
                removeProduct({ variantId: item_id });
                return;
        }
    }

};


const addEventListeners = () => {
    document.addEventListener('cart:change', (event) => {
        init({ firstInit: false, event: event });
    });
};


const fetchCartData = async () => {
    try {
        // Check cache first
        const now = Date.now();
        if (cartDataCache && (now - lastCacheTime) < cacheExpiry) {
            return cartDataCache;
        }

        const response = await fetch('/cart?view=free-gift-data');
        if (!response.ok) throw new Error('Failed to fetch cart data');
        const data = await response.json();

        // Update cache
        cartDataCache = data;
        lastCacheTime = now;

        return data;
    } catch (error) {
        console.error('Error fetching cart data:', error);
    }
};

const updateCartProperty = async (property = null, value = null, callBack = null) => {

    try {
        const config = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                attributes: {
                    [property]: value
                }
            })
        };

        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', config);
        if (!response.ok) {
            console.error('Failed to update cart with gift removal property');
        }

        if (callBack) callBack();

    } catch (error) {
        console.error('Error updating cart:', error);
    }
}

const addProduct = async ({ variantId = null, quantity = 1, properties = {}, callBack = null }) => {
    if (!variantId) {
        console.error('Variant ID is required');
        return;
    }

    let sectionsToBundle = ["variant-added"];

    const cartDrawerSection = document.querySelector('cart-drawer');
    if (cartDrawerSection) {
        sectionsToBundle.push(cartDrawerSection.dataset?.sectionId || null);
    }

    const productData = {
        items: [{
            id: variantId,
            quantity,
            properties
        }],
        sections: sectionsToBundle.join(","),
        sections_url: `${ window.Shopify.routes.root }variants/${ variantId }`
    };

    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(productData)
    };

    const writeError = (error) => {
        const errorText = error.message ? error.message : 'Something went wrong';
        alert(errorText);
    }

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', config);

        const responseJson = await response.json();
        if (!response.ok) {
            writeError(responseJson);
            throw new Error(responseJson.message);
        }


        const cartData = await fetch(window.Shopify.routes.root + 'cart.js', config);

        const cartDataResponse = await cartData.json();
        if (!cartData.ok) {
            writeError(cartDataResponse);
            throw new Error(cartDataResponse.message);
        }

        cartDataResponse["sections"] = responseJson["sections"] || [];

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
                baseEvent: "line-item:change",
                cart: cartDataResponse
            }
        }));

        setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.show();
                requestAnimationFrame(() => {
                    cartDrawer.focus();
                });
            }
        }, 0);

        if (callBack) callBack();
    } catch (error) {
        console.error('Error:', error);
    }
};

const removeProduct = async ({ variantId = null, quantity = 0, callBack = null }) => {
    changeProduct({ variantId: variantId, quantity: quantity, callBack: callBack });
};

const changeProduct = async ({ variantId = null, quantity = 0, callBack = null }) => {
    if (!variantId) {
        console.error('Variant ID is required');
        return;
    }

    let sectionsToBundle = [];
    const cartDrawerSection = document.querySelector('cart-drawer');
    if (cartDrawerSection) {
        sectionsToBundle.push(cartDrawerSection.dataset?.sectionId || null);
    }

    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            sections: sectionsToBundle
        })
    };

    const response = await fetch(window.Shopify.routes.root + `cart/change?id=${ variantId }&quantity=${ quantity }&sections=${ sectionsToBundle.join(",") }`, config);
    const responseJson = await response.json();
    if (!response.ok) {
        console.error('Error:', responseJson);
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: {
            baseEvent: "line-item:change",
            cart: responseJson
        }
    }));

    if (callBack) callBack();
};



campaignFreeGift();


const GtcFreeGiftLineItemQuantity = class extends LineItemQuantity {
    constructor() {
        super();

        this.addEventListener("click", this._onRemoveLinkClicked);
    }

    connectedCallback() {
        this.settings = {
            campaign: this.dataset.campaign,
        }
    }

    _onRemoveLinkClicked(event) {
        event.preventDefault();

        let key = 'gift_manually_removed';
        if (this.settings.campaign) {
            key = `gift_manually_removed_${ this.settings.campaign }`;
        }

        Promise.resolve(updateCartProperty(key, 'true')).then(() => {
            super._onRemoveLinkClicked(event);
        });
    }
};


if (!window.customElements.get("gtc-free-gift-line-item-quantity")) {
    window.customElements.define("gtc-free-gift-line-item-quantity", GtcFreeGiftLineItemQuantity);
}

export { addProduct };